import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DividerModule } from './../../common/divider/divider.module';
import { HeadingModule } from './../../common/heading/heading.module';
import { IconHelpModule } from './../../common/icon-help/icon-help.module';
import { IconModule } from './../../common/icon/icon.module';
import { TooltipModule } from './../../common/tooltip/tooltip.module';
import { DialogHeaderComponent } from './dialog-header.component';

@NgModule({
  declarations: [DialogHeaderComponent],
  exports: [DialogHeaderComponent],
  imports: [HeadingModule, IconModule, CommonModule, IconHelpModule, TooltipModule, DividerModule],
})
export class DialogHeaderModule {}
export { DialogHeaderComponent } from './dialog-header.component';
